import { render } from "./SpecificationInput.vue?vue&type=template&id=37c957bc"
import script from "./SpecificationInput.vue?vue&type=script&lang=js"
export * from "./SpecificationInput.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/bomo-staging/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__